import { Button, 
         Dialog, 
         DialogActions, 
         DialogContent, 
         DialogTitle, 
         FormControl, 
         Grid, 
         InputLabel, 
         MenuItem, 
         Select, 
         TextField, 
         Typography
       }                                    from "@mui/material";
import { ServiceNodeData }                  from "./CustomNode";
import { Node }                             from "@xyflow/react";
import { useState }                         from "react";

export interface CreateConfig {
  configType : string;
  configKey : string;
  label : string;
  description : string;
}

export interface CreateConfigComponentProps {
  node      : Node<ServiceNodeData>;
  isOpen    : boolean;
  onSave    : (config : CreateConfig) => void;
  onClose   : () => void;
}

export const CreateConfigComponent = ({ node, isOpen, onClose, onSave } : CreateConfigComponentProps) => {

  const [configType, setConfigType] = useState<string>("");
  const [configKey, setConfigKey] = useState<string>("");
  const [label, setLabel] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [error, setError] = useState<string>("");

  const handleSave = () => {

    if (configType === "" || configKey === "" || label === "" || description === "") {
      setError("Please fill in all fields");
      return
    }

    setError("");

    onSave({
      configType,
      configKey,
      label,
      description
    });
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Add New Config</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid size={{xs: 12}}>
            <FormControl fullWidth>
              <InputLabel>Workflow Component</InputLabel>
              <Select
                value={node.data.label}
                label="Workflow Component"
                disabled>
                <MenuItem value={node.data.label}>
                  {node.data.label}
                </MenuItem>
              
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{xs: 12}}>
            <TextField
              required
              fullWidth
              label="Config Type"
              value={configType}
              onChange={(e) => setConfigType(e.target.value)}
            />
          </Grid>
          <Grid size={{xs: 12}}>
            <TextField
              required
              fullWidth
              label="Config Key"
              value={configKey}
              onChange={(e) => setConfigKey(e.target.value)}
            />
          </Grid>
          <Grid size={{xs: 12}}>
            <TextField
              required
              fullWidth
              label="Label"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
            />
          </Grid>
          <Grid size={{xs: 12}}>
            <TextField
              required
              fullWidth
              label="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              multiline
              rows={2}
            />
          </Grid>
        </Grid>

        {error && (
          <Typography color="error" sx={{ mt: 2, textAlign: 'center' }}>
            {error}
          </Typography>
        )}

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Add</Button>
      </DialogActions>
    </Dialog>
  );
};